<template lang="pug">
core-node(
  :loading="loading"
  :items="roles"
  add-title="Добавить роль"
  @open-create="dialog = true"
  @delete="deleteProject"
  @edit="editProject"
)
  template(#children="{ item, selected }")
    questions(
      v-if="selected === item.id"
      :parent-id="null"
      :project-role-id="item.id"
    )

  v-dialog(v-model="dialog" max-width="500px" dark)
    v-card.pa-5
      p.text-h5 {{ title }}
      v-text-field(
        required
        v-model="form.name" filled label="Название роли")
      v-btn.mr-4(
        :disabled="!form.name"
        color="success"
        @click="saveProject"
      ) Сохранить

      v-btn(text @click='dialog = false') Отменить
  confirm-form-dialog(
    v-model="deleteProjectDialog"
    message="Действительно удалить?"
    @accept="acceptDeleteProject"
  )

</template>

<script>
import ConfirmFormDialog from '@/components/dialogs/ConfirmFormDialog.vue';
import { CRUDProjectRoles } from '@/services/API/_crud';
import SelectProject from '@/components/inputs/SelectProject.vue';
import Questions from './Questions.vue';
import CoreNode from './CoreNode.vue';

const DEFAULT_FORM = {
  name: '',
};

export default {
  components: {
    ConfirmFormDialog, SelectProject, Questions, CoreNode,
  },
  props:{
    projectId: { type:Number, required: false, default:null },
  },
  data() {
    return {
      roles: [],
      dialog: false,

      deleteProjectDialog: false,
      deleteProjectId: null,

      loading: false,

      form: { ...DEFAULT_FORM },

    };
  },
  computed: {
    title() {
      return this.form.id ? 'Изменение роли' : 'Создание роли';
    },

  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      const params = {
        'per-page': -1,
        'sort': '-id',
        'search[project_id]':this.projectId,
      };

      this.loading = true;

      try {
        const response = await CRUDProjectRoles.getAll(params);
        this.roles = response.data.data;
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      }
      this.loading = false;
    },

    deleteProject(id) {
      this.deleteProjectDialog = true;
      this.deleteProjectId = id;
    },

    editProject(data) {
      this.form = { ...data };
      this.dialog = true;
    },

    async acceptDeleteProject() {
      this.deleteProjectDialog = false;
      await CRUDProjectRoles.delete(this.deleteProjectId);
      this.roles = this.roles.filter(({ id }) => id !== this.deleteProjectId);
    },

    async saveProject() {
      this.dialog = false;

      const params = {
        ...this.form,
        project_id:this.projectId,
      };

      if (this.form.id) {
        const response = await CRUDProjectRoles.update(this.form.id, params);
        const index = this.roles.findIndex(({ id }) => id === this.form.id);
        const newProjects = [...this.roles];
        newProjects[index] = response.data.data;
        this.roles = newProjects;
      } else {
        const response = await CRUDProjectRoles.create(params);
        this.roles.unshift(response.data.data);
      }
      this.form = { ...DEFAULT_FORM };
    },
  },
};
</script>
